module.exports = __webpack_public_path__ + "img/img_sensor_speed.8b437f2c.jpg";